import Vue from 'vue'
import SubscriptionReviews from "./SubscriptionReviews.vue";
import Timer from "./Timer.vue";
import TimeoutModal from "./TimeoutModal.vue";
import TimeoutConfirmationModal from "./TimeoutConfirmationModal.vue";
import FAQ from "./FAQ.vue";
import ExpandPanel from "./ExpandPanel.vue";

Vue.component('subscription-reviews', SubscriptionReviews)
Vue.component('offer-timer', Timer)
Vue.component('timeout-modal', TimeoutModal)
Vue.component('timeout-confirmation-modal', TimeoutConfirmationModal)
Vue.component('faq-list', FAQ)
Vue.component('expand-panel', ExpandPanel)
